"use strict";
exports.__esModule = true;
var PLACEMENTS = {
    "bottom-center": { bottom: 0, left: "50%", transform: "translateX(-50%)" },
    "bottom-left": { bottom: 0, left: 0 },
    "bottom-right": { bottom: 0, right: 0 },
    "top-center": { top: 0, left: "50%", transform: "translateX(-50%)" },
    "top-left": { top: 0, left: 0 },
    "top-right": { top: 0, right: 0 }
};
exports.PLACEMENTS = PLACEMENTS;
var DEFAULT_AUTO_DISMISS_TIMEOUT = 5000;
exports.DEFAULT_AUTO_DISMISS_TIMEOUT = DEFAULT_AUTO_DISMISS_TIMEOUT;
var DEFAULT_PLACEMENT = "top-right";
exports.DEFAULT_PLACEMENT = DEFAULT_PLACEMENT;
var DEFAULT_TRANSITION_DURATION = 220;
exports.DEFAULT_TRANSITION_DURATION = DEFAULT_TRANSITION_DURATION;
